import React from 'react'
import DialogInputLabel from './DialogInputLabel'
import RadioGroup from '@tencent/spaui-radiogroup'

const DialogUploadTypeRadioGroup = ({ onChange, value, data, label = '上传方式', vertical = false }) => {
    return (
        <div className="track-body-item">
            <DialogInputLabel label={label} />
            <RadioGroup data={data} value={value} vertical={vertical} onChange={(e, val) => onChange(val)} />
        </div>
    )
}

export default DialogUploadTypeRadioGroup
